<template>
  <svg
    :width="width ? width : height ? height : 17"
    :height="height ? height : width ? width : 17"
    viewBox="0 0 17 17"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >

    <path
      d="M16.144 4.593l-1.483 1.483a.386.386 0 0 1-.546 0l-3.57-3.57a.386.386 0 0 1 0-.547L12.026.476a1.547 1.547 0 0 1 2.184 0l1.933 1.933c.605.602.605 1.58 0 2.184zm-6.873-1.36L.824 11.679l-.682 3.908a.773.773 0 0 0 .894.894l3.908-.685 8.447-8.446a.386.386 0 0 0 0-.547l-3.57-3.57a.39.39 0 0 0-.55 0zm-5.15 7.723a.448.448 0 0 1 0-.637l4.953-4.954a.448.448 0 0 1 .637 0 .448.448 0 0 1 0 .637l-4.953 4.954a.448.448 0 0 1-.637 0zM2.96 13.66h1.544v1.167l-2.075.364-1-1 .363-2.075H2.96v1.544z"
      :fill="iconColor"
      fill-rule="nonzero"
    />

  </svg>
</template>

<script>
export default {
  name: 'filled-circle-pen',
  props: {
    iconColor: {
      type: String,
      default: '#0F1C70',
    },
    height: {
      type: Number,
      required: false,
    },
    width: {
      type: Number,
      required: false,
    },
  },
};
</script>
